module.exports = __webpack_public_path__ + "img/img.01e1d2ce.png";